import { StudentAssignment } from "../features/student-assignments/state";

export function isStudentAssignment(value: any): value is StudentAssignment {
  return value.sectionStats && value.questionStats && value.averageStats;
}
